import React, { useEffect } from 'react';
import { postApi } from '../../apiUtils';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { CustomersForm } from '../../forms/customers/CustomersForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { CustomerInputs } from '../../types/customer.types';
import { API_URL } from '../../utils/apiUrl';

export function CustomersNew() {
  const { translate } = useTranslation();
  const transFormName = 'Customer.Create';
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'New customer',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Customers', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const formData: CustomerInputs = {
    id: 0,
    name: '',
    visible: true,
  };

  const onSubmit = async (e) => {
    startLoading();
    if (e !== null) e.preventDefault();
    let isOk = false;
    await postApi<CustomerInputs>({
      url: API_URL.CUSTOMER_POST,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper heading={translate!('New customer', transFormName)}>
      <CustomersForm onSubmit={onSubmit} formData={formData} />
    </PageContentWrapper>
  );
}

export default CustomersNew;
